import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Observable } from 'rxjs';

import { AuthenticationService } from 'app/shared/authentication';
import { AuthenticatedUser } from 'app/shared/graph';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'admin-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    imports: [MatIcon, AsyncPipe]
})
export class HomePageComponent implements OnInit {
    private readonly authenticationService = inject(AuthenticationService);

    me$: Observable<AuthenticatedUser>;

    ngOnInit(): void {
        this.me$ = this.authenticationService.authenticatedUser$;
    }
}
